import * as m from "@paraglide/messages"
import type { SupportedLocale } from "@site-types/site"

export type RouteLabelPage =
  | "calendar"
  | "careers"
  | "company"
  | "contact"
  | "home"
  | "index"
  | "news"
  | "work"

export type RouteLabels = {
  layoutTitle: string
  pageTitle: string
  page: string
  description?: string
  ogTitle?: string
  ogDescription?: string
}

export function metadataDefaults(locale: SupportedLocale) {
  return {
    author: m.metadata_author({}, { locale }),
    publisher: m.metadata_publisher({}, { locale }),
    siteName: m.metadata_ogSiteName({}, { locale }),
    twitterCard: m.metadata_twitterCard({}, { locale }),
    twitterSite: m.metadata_twitterSite({}, { locale }),
    twitterTitle: m.metadata_twitterTitle({}, { locale }),
    twitterDescription: m.metadata_twitterDescription({}, { locale }),
    twitterImage: m.metadata_twitterImage({}, { locale }),
    descriptionFallback: m.metadata_descriptionFallback({}, { locale }),
    ogTitleFallback: m.metadata_ogTitleFallback({}, { locale }),
    ogDescriptionFallback: m.metadata_ogDescriptionFallback({}, { locale }),
    ogImageFallback: m.metadata_ogImageFallback({}, { locale }),
  }
}

export function pageLabels(locale: SupportedLocale, page: string) {
  const labels = {
    calendar: {
      layoutTitle: m.calendar_meta_layoutTitle({}, { locale }),
      pageTitle: m.calendar_meta_pageTitle({}, { locale }),
      page: m.calendar_meta_page({}, { locale }),
      description: m.calendar_meta_description({}, { locale }),
      ogTitle: m.calendar_meta_ogTitle({}, { locale }),
      ogDescription: m.calendar_meta_ogDescription({}, { locale }),
    },
    careers: {
      layoutTitle: m.careers_meta_layoutTitle({}, { locale }),
      pageTitle: m.careers_meta_pageTitle({}, { locale }),
      page: m.careers_meta_page({}, { locale }),
      description: m.careers_meta_description({}, { locale }),
      ogTitle: m.careers_meta_ogTitle({}, { locale }),
      ogDescription: m.careers_meta_ogDescription({}, { locale }),
    },
    company: {
      layoutTitle: m.company_meta_layoutTitle({}, { locale }),
      pageTitle: m.company_meta_pageTitle({}, { locale }),
      page: m.company_meta_page({}, { locale }),
      description: m.company_meta_description({}, { locale }),
      ogTitle: m.company_meta_ogTitle({}, { locale }),
      ogDescription: m.company_meta_ogDescription({}, { locale }),
    },
    contact: {
      layoutTitle: m.contact_meta_layoutTitle({}, { locale }),
      pageTitle: m.contact_meta_pageTitle({}, { locale }),
      page: m.contact_meta_page({}, { locale }),
      description: m.contact_meta_description({}, { locale }),
      ogTitle: m.contact_meta_ogTitle({}, { locale }),
      ogDescription: m.contact_meta_ogDescription({}, { locale }),
    },
    home: {
      layoutTitle: m.home_meta_layoutTitle({}, { locale }),
      pageTitle: m.home_meta_pageTitle({}, { locale }),
      page: m.home_meta_page({}, { locale }),
      description: m.metadata_descriptionFallback({}, { locale }),
      ogTitle: m.metadata_ogTitleFallback({}, { locale }),
      ogDescription: m.metadata_ogDescriptionFallback({}, { locale }),
    },
    index: {
      layoutTitle: m.home_meta_layoutTitle({}, { locale }),
      pageTitle: m.home_meta_pageTitle({}, { locale }),
      page: m.home_meta_page({}, { locale }),
      description: m.metadata_descriptionFallback({}, { locale }),
      ogTitle: m.metadata_ogTitleFallback({}, { locale }),
      ogDescription: m.metadata_ogDescriptionFallback({}, { locale }),
    },
    news: {
      layoutTitle: m.news_meta_layoutTitle({}, { locale }),
      pageTitle: m.news_meta_pageTitle({}, { locale }),
      page: m.news_meta_page({}, { locale }),
      description: m.news_meta_description({}, { locale }),
      ogTitle: m.news_meta_ogTitle({}, { locale }),
      ogDescription: m.news_meta_ogDescription({}, { locale }),
    },
    work: {
      layoutTitle: m.work_meta_layoutTitle({}, { locale }),
      pageTitle: m.work_meta_pageTitle({}, { locale }),
      page: m.work_meta_page({}, { locale }),
      description: m.work_meta_description({}, { locale }),
      ogTitle: m.work_meta_ogTitle({}, { locale }),
      ogDescription: m.work_meta_ogDescription({}, { locale }),
    },
  } as const satisfies Record<RouteLabelPage, RouteLabels>
  const key = page in labels ? (page as RouteLabelPage) : "home"
  return { ...labels[key], page: labels[key].page.toLowerCase() }
}
